<template>
  <section :class="$style.access">
    <sub-title :class="$style.title" :title="'アクセス'"></sub-title>
    <div :class="$style.map">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3210.100549678952!2d136.43436531558123!3d36.430951296096524!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5ff8521ee4f9209f%3A0xb5cd4502e3d81222!2z5p2-5LqV56eA5Zac44OZ44O844K544Oc44O844Or44Of44Ol44O844K444Ki44Og!5e0!3m2!1sja!2sjp!4v1573454159918!5m2!1sja!2sjp"
        width="800"
        height="350"
        frameborder="0"
        style="border: 0"
        allowfullscreen
      ></iframe>
    </div>

    <div :id="$style.detail">
      <div :class="$style.grid">
        <div :id="$style.address">
          <div>【住所】</div>
          <span>&#12306;929-0126</span>
          <span>石川県能美市山口町タ58番地</span>
        </div>
        <div :id="$style.tel">
          <div>【電話番号】</div>
          <span>
            <a href="tel">0761-22-2447</a>
          </span>
        </div>
        <div :id="$style.parking_lot">
          無料駐車場を完備しております。
          <ul>
            <li>P1 大型バス7台, 普通車30台, 障害者用3台</li>
            <li>P2 普通車30台</li>
            <li>P3 大型バス7台, 普通車84台</li>
            <li>2輪車用サイクルポート</li>
          </ul>
        </div>
      </div>
      <div :class="$style.grid">
        <div :id="$style.car" :class="$style.column">
          <dl>
            <dt>・車でお越しの方</dt>
            <dd>
              <span>北陸自動車道</span>
              <span>小松ICより約3分</span>
              <span>能美根上IC(ETC専用)より約8分</span>
            </dd>
          </dl>
        </div>
        <div :id="$style.airplain" :class="$style.column">
          <dl>
            <dt>・飛行機でお越しの方</dt>
            <dd>
              <span>小松空港からタクシー</span>
              <span>（所要時間：約10分）</span>
            </dd>
          </dl>
        </div>
        <div :id="$style.train" :class="$style.column">
          <dl>
            <dt>・電車でお越しの方</dt>
            <dd>
              <span>小松駅（北陸新幹線・IRいしかわ鉄道線）からタクシー（所要時間：約15分）</span><br>

              <span>能美根上駅（IRいしかわ鉄道線）からタクシー</span>
              <span :class="$style.tab">（所要時間：約10分）</span>
            </dd>
          </dl>
        </div>
        <div :id="$style.bus" :class="$style.column">
          <dl>
            <dt>・高速バスでお越しの方</dt>
            <dd>
              <span>小松インター（北陸自動車道）から徒歩</span>
              <span :class="$style.tab">（所要時間：約20分）</span>
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import Vue from "vue";
import SubTitle from "@/components/atoms/SubTitle.vue";

export default Vue.extend({
  name: "AccessVisual",

  components: {
    SubTitle,
  },
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  .access {
    display: grid;
    .title {
      grid-row: 1;
    }
    .map {
      grid-row: 3;
      iframe {
        width: 100%;
        height: 220px;
      }
    }
    #detail {
      margin: 0px 20px;
      margin-bottom: 20px;
      grid-row: 2;
      .grid {
        display: grid;

        #address {
          grid-row: 1;
          display: flex;
          flex-direction: column;
        }
        #tel {
          grid-row: 2;
          margin-top: 7px;
        }
        #parking_lot {
          grid-row: 3;
          ul {
            padding-left: 17px;
          }
        }

        #car {
          grid-row: 1;
        }
        #airpalin {
          grid-row: 2;
        }
        #train {
          grid-row: 3;
        }
        #bus{
          grid-row: 4
        }
        .column {
          dl {
            dd {
              display: flex;
              flex-direction: column;
              margin-left: 10px;
              .tab {
                margin-left: 10px;
              }
            }
          }
        }
      }
    }
  }
}
@media only screen and (min-width: 1024px) {
  .access {
    iframe {
      width: 100%;
    }
    #detail {
      // margin: 0px 90px;
      margin-top: 20px;
      .grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 0.5fr;

        #address {
          grid-column: 1/2;
          grid-row: 1/2;
          display: flex;
          flex-direction: column;
        }
        #tel {
          grid-column: 1/2;
          grid-row: 2/3;
          margin-top: 7px;
        }
        #parking_lot {
          grid-column: 2/3;
          grid-row: 1/3;
        }

        #car {
          grid-column: 1/2;
          grid-row: 1/2;
        }
        #airpalin {
          grid-column: 1/2;
          grid-row: 2/3;
        }
        #train {
          grid-column: 2/3;
          grid-row: 1/2;
        }
        #bus{
          grid-column:2/3;
          grid-row:2/3
        }
        .column {
          margin: 10px 0px;
          dl {
            dd {
              display: flex;
              flex-direction: column;
              .tab {
                margin-left: 10px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
